import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "icon"]

  connect() {
    // Check if there's a saved state in localStorage
    const storageKey = this.element.dataset.collapseKey
    if (storageKey) {
      const isCollapsed = localStorage.getItem(storageKey) === 'true'
      if (isCollapsed) {
        this.collapse(false)
      }
    }
  }

  toggle() {
    const isCollapsed = this.contentTarget.classList.contains('hidden')

    if (isCollapsed) {
      this.expand()
    } else {
      this.collapse()
    }

    // Save state to localStorage if key is provided
    const storageKey = this.element.dataset.collapseKey
    if (storageKey) {
      localStorage.setItem(storageKey, !isCollapsed)
    }
  }

  expand() {
    this.contentTarget.classList.remove('hidden')
    if (this.hasIconTarget) {
      this.iconTarget.classList.remove('fa-chevron-right')
      this.iconTarget.classList.add('fa-chevron-down')
    }
  }

  collapse(animate = true) {
    this.contentTarget.classList.add('hidden')
    if (this.hasIconTarget) {
      this.iconTarget.classList.remove('fa-chevron-down')
      this.iconTarget.classList.add('fa-chevron-right')
    }
  }
}
